export { akamaiGetDevice } from "./akamaiGetDevice";
export { getHost } from "./getHost";
export { getPartnerOnServerSide } from "./getPartnerOnServerSide";
